import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useSearchParams } from 'react-router-dom'
import styled from '@emotion/styled'
import { Box, CircularProgress, LinearProgress, SelectChangeEvent } from '@mui/material'
import { H3 } from '../../../../layouts/TextStyles'
import SingleSelect from '../../../../components/muiComponents/singleSelect'
import { topicApiSlice } from '../../../../features/topic/topicSlice'
import { CourseSubjectState } from '../../../../features/types'
import { TEST } from '../../../../utils/constants'
import TopicProgressCard from '../components/TopicProgressCard'

interface Props {
    subjectId: number | null
    studentId: number
    loadingSubjects?: boolean
}

const TestTab: React.FC<Props> = ({ subjectId, studentId, loadingSubjects = false }) => {
    const { formatMessage } = useIntl()
    const [searchParams] = useSearchParams()
    const [courseSubject, setCourseSubject] = useState<number>(Number(searchParams.get('courseSubjectId')) || null)
    const { data: topics = [], isFetching } =
        topicApiSlice.useGetStudentTopicTestAnalysisQuery(
            { courseSubjectId: courseSubject, studentId },
            { skip: !courseSubject },
        )

    useEffect(() => {
        if (subjectId) {
            setCourseSubject(subjectId)
        }
    }, [subjectId])

    return (
        <Box>
            {isFetching ? (
                <LinearProgress />
            ) : (
                topics.map((topic) => (
                    <TopicProgressCard
                        key={topic.courseTopicId}
                        topic={topic}
                        studentId={studentId}
                        type={TEST}
                    />
                ))
            )}
        </Box>
    )
}

export default TestTab
